import axios from 'axios';
import { flow, Instance, types } from 'mobx-state-tree';

import endpoints from '@configs/endpoints';
import { AddressType } from '@constants/enum';
import Common from './common';

const Colony = types.model({ colony: '' });

const Address = types
  .compose(
    Common,
    types.model({
      addressId: '',
      type: types.union(
        types.literal(AddressType.UNKNOWN_ADDRESS),
        types.literal(AddressType.PERSONAL),
        types.literal(AddressType.HOME),
        types.literal(AddressType.LEGAL),
      ),
      city: '',
      state: '',
      country: '',
      line1: '',
      zipCode: '',
      municipality: '',
      colony: '',
      refId: '',
      formattedAddress: '',
      numeroInterior: '',
      numeroExterior: '',
      street: '',
      fetchedFromZipcode: false,
      colonyOptions: types.maybeNull(types.array(Colony)),
    }),
  )
  .views((self) => ({
    get getFormattedAddress() {
      //
      return `${self.street} ${self.numeroExterior}, ${self.zipCode}, ${self.city}, ${self.state}`;
    },
    get getLine1() {
      //
      return `${self.street} ${self.numeroExterior}`;
    },
    get canSubmit() {
      return (
        [
          self.street,
          self.zipCode,
          self.numeroExterior,
          self.city,
          self.state,
          self.municipality,
        ].every((field) => field?.trim().length) && self.zipCode.length === 5
      );
    },
  }))
  .actions((self) => ({
    update: (data: typeof self) => {
      self.street = data.street || self.street;
      self.zipCode = data.zipCode || self.zipCode;
      self.numeroExterior = data.numeroExterior || self.numeroExterior;
      self.numeroInterior = data.numeroInterior || self.numeroInterior;
      self.colony = data.colony || self.colony;
      self.municipality = data.municipality || self.municipality;
      self.city = data.city || self.city;
      self.state = data.state || self.state;
      self.country = data.country || self.country;
      self.line1 = data.line1 || self.line1;
      self.formattedAddress = data.formattedAddress || self.formattedAddress;
    },
    clearZipFills: () => {
      self.colony = '';
      self.colonyOptions = null;
      self.municipality = '';
      self.state = '';
      self.city = '';
      self.fetchedFromZipcode = false;
    },
  }))
  .actions((self) => ({
    fetchAddressFromZip: flow(function* (zipCode) {
      try {
        self.clearZipFills();
        const { data } = yield axios.get(endpoints.addressFromZipCode(zipCode));
        const addresses = data.addresses;

        if (addresses && addresses.length) {
          self.update(addresses[0]);
          self.fetchedFromZipcode = true;
          self.colonyOptions = addresses.map((adr: { colony: string }) => ({
            colony: adr.colony,
          }));
        }
        return data;
      } catch (error) {
        console.warn(error);
      }
    }),
  }));

export type TAddressStore = Instance<typeof Address>;

export default Address;
